'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IntegrationManagers = require('../../../integrations/IntegrationManagers');

var _matrixJsSdk = require('matrix-js-sdk');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _Terms = require('../../../Terms');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ScalarMessaging = require('../../../ScalarMessaging');

var _ScalarMessaging2 = _interopRequireDefault(_ScalarMessaging);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var TabbedIntegrationManagerDialog = function (_React$Component) {
    (0, _inherits3.default)(TabbedIntegrationManagerDialog, _React$Component);

    function TabbedIntegrationManagerDialog(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, TabbedIntegrationManagerDialog);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TabbedIntegrationManagerDialog.__proto__ || (0, _getPrototypeOf2.default)(TabbedIntegrationManagerDialog)).call(this, props));

        _this.openManager = function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(i) {
                var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var manager, client;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(i === _this.state.currentIndex && !force)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                manager = _this.state.managers[i];
                                client = manager.getScalarClient();

                                _this.setState({
                                    busy: true,
                                    currentIndex: i,
                                    currentLoading: true,
                                    currentConnected: false,
                                    currentScalarClient: client
                                });

                                _ScalarMessaging2.default.setOpenManagerUrl(manager.uiUrl);

                                client.setTermsInteractionCallback(function (policyInfo, agreedUrls) {
                                    // To avoid visual glitching of two modals stacking briefly, we customise the
                                    // terms dialog sizing when it will appear for the integrations manager so that
                                    // it gets the same basic size as the IM's own modal.
                                    return (0, _Terms.dialogTermsInteractionCallback)(policyInfo, agreedUrls, 'mx_TermsDialog_forIntegrationsManager');
                                });

                                _context.prev = 7;
                                _context.next = 10;
                                return (0, _bluebird.resolve)(client.connect());

                            case 10:
                                if (!client.hasCredentials()) {
                                    _this.setState({
                                        busy: false,
                                        currentLoading: false,
                                        currentConnected: false
                                    });
                                } else {
                                    _this.setState({
                                        busy: false,
                                        currentLoading: false,
                                        currentConnected: true
                                    });
                                }
                                _context.next = 19;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](7);

                                if (!(_context.t0 instanceof _Terms.TermsNotSignedError)) {
                                    _context.next = 17;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 17:

                                console.error(_context.t0);
                                _this.setState({
                                    busy: false,
                                    currentLoading: false,
                                    currentConnected: false
                                });

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[7, 13]]);
            }));

            return function (_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.state = {
            managers: _IntegrationManagers.IntegrationManagers.sharedInstance().getOrderedManagers(),
            busy: true,
            currentIndex: 0,
            currentConnected: false,
            currentLoading: true,
            currentScalarClient: null
        };
        return _this;
    }

    (0, _createClass3.default)(TabbedIntegrationManagerDialog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.openManager(0, true);
        }
    }, {
        key: '_renderTabs',
        value: function _renderTabs() {
            var _this3 = this;

            var AccessibleButton = _index2.default.getComponent("views.elements.AccessibleButton");
            return this.state.managers.map(function (m, i) {
                var classes = (0, _classnames2.default)({
                    'mx_TabbedIntegrationManagerDialog_tab': true,
                    'mx_TabbedIntegrationManagerDialog_currentTab': _this3.state.currentIndex === i
                });
                return _react2.default.createElement(
                    AccessibleButton,
                    {
                        className: classes,
                        onClick: function onClick() {
                            return _this3.openManager(i);
                        },
                        key: 'tab_' + i,
                        disabled: _this3.state.busy
                    },
                    m.name
                );
            });
        }
    }, {
        key: '_renderTab',
        value: function _renderTab() {
            var IntegrationsManager = _index2.default.getComponent("views.settings.IntegrationsManager");
            var uiUrl = null;
            if (this.state.currentScalarClient) {
                uiUrl = this.state.currentScalarClient.getScalarInterfaceUrlForRoom(this.props.room, this.props.screen, this.props.integrationId);
            }
            return _react2.default.createElement(IntegrationsManager, {
                configured: true,
                loading: this.state.currentLoading,
                connected: this.state.currentConnected,
                url: uiUrl,
                onFinished: function onFinished() {/* no-op */}
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'mx_TabbedIntegrationManagerDialog_container' },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_TabbedIntegrationManagerDialog_tabs' },
                    this._renderTabs()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_TabbedIntegrationManagerDialog_currentManager' },
                    this._renderTab()
                )
            );
        }
    }]);
    return TabbedIntegrationManagerDialog;
}(_react2.default.Component);

TabbedIntegrationManagerDialog.propTypes = {
    /**
     * Called with:
     *     * success {bool} True if the user accepted any douments, false if cancelled
     *     * agreedUrls {string[]} List of agreed URLs
     */
    onFinished: _propTypes2.default.func.isRequired,

    /**
     * Optional room where the integration manager should be open to
     */
    room: _propTypes2.default.instanceOf(_matrixJsSdk.Room),

    /**
     * Optional screen to open on the integration manager
     */
    screen: _propTypes2.default.string,

    /**
     * Optional integration ID to open in the integration manager
     */
    integrationId: _propTypes2.default.string
};
exports.default = TabbedIntegrationManagerDialog;
module.exports = exports['default'];
//# sourceMappingURL=TabbedIntegrationManagerDialog.js.map